<template>
  <div class="communication-section">
    <div class="communication-title" :class="curLang"></div>
    <div class="book book-kol" :class="[curLang, { mobile: isMobile }]">
      <div class="kol-left">
        <div class="kol-subtitle">
          <span>{{ langData.kolSubtitle }}</span>
        </div>
        <div class="kol-content">{{ langData.kolContent }}</div>
        <div class="kol-view-btn btns" @click="emit('showKolPopup')">
          <span>{{ langData.kolViewBtn }}</span>
        </div>
      </div>
      <div class="kol-picture"></div>
    </div>
  </div>
</template>

<script setup>
import { inject } from "vue";
import LanguageHook from "@/hooks/language";

const { curLang, langData } = LanguageHook();
const isMobile = inject("isMobile");
const emit = defineEmits(["switch-com-tab", "showKolPopup"]);
</script>

<style scoped lang="less">
.book {
  position: relative;
  width: 1584px;
  height: 864px;
  margin: 40px auto 0;

  &.book-kol {
    background: url("@images/home/comment-module-bg.webp") center/contain no-repeat;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 142px 185px 180px;
    box-sizing: border-box;
  }

  .kol-left {
    display: flex;
    flex-direction: column;
    height: 100%;
    gap: 30px;
    width: 550px;
    box-sizing: border-box;
    padding: 86px 10px 0 50px;
    align-items: center;
  }

  .kol-subtitle {
    width: 516px;
    height: 89px;
    background: url("@images/home/comment-subtitle-bg.png") center/contain no-repeat;
    display: flex;
    align-items: center;
    justify-content: center;

    span {
      font-size: 34px;
      line-height: 36px;
      color: #fff;
      paint-order: stroke fill;
      -webkit-text-stroke: 1px #ed663d;
    }
  }

  .kol-content {
    font-size: 30px;
    line-height: 36px;
    color: #895a32;
  }

  .kol-view-btn {
    width: 333px;
    height: 95px;
    background: url("@images/home/btn-view-bg.png") center/contain no-repeat;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: absolute;
    bottom: 250px;

    span {
      font-size: 28px;
      font-weight: bold;
      color: #ffffff;
      paint-order: stroke fill;
      -webkit-text-stroke: 3px #6b8624;
    }
  }

  .kol-picture {
    width: 621px;
    height: 693px;
    background: url("@images/home/comment-picture-zh-CN.webp") center/contain no-repeat;
    flex-shrink: 0;
  }

  &.en-US .kol-picture {
    background-image: url("@images/home/comment-picture-en-US.webp");
  }

  &.th-TH .kol-picture {
    background-image: url("@images/home/comment-picture-th-TH.webp");
  }

  &.id-ID .kol-picture {
    background-image: url("@images/home/comment-picture-id-ID.webp");
  }

  &.zh-CN .kol-picture {
    background-image: url("@images/home/comment-picture-zh-CN.webp");
  }
}

.mobile {
  .book {
    width: 750px;
    height: 409px;
    margin: 30px auto 0;

    &.book-kol {
      padding: 0 67px 88px 85px;
    }

    .kol-left {
      width: 260px;
      gap: 14px;
      padding: 41px 5px 0 24px;
    }

    .kol-subtitle {
      width: 244px;
      height: 42px;
      span {
        font-size: 16px;
        line-height: 18px;
      }
    }

    .kol-content {
      font-size: 14px;
      line-height: 17px;
    }

    .kol-view-btn {
      width: 158px;
      height: 45px;
      bottom: 118px;
      span {
        font-size: 13px;
        -webkit-text-stroke: 1px #6b8624;
      }
    }

    .kol-picture {
      width: 294px;
      height: 328px;
    }
  }
}
</style>
